(function () {
  var FAVORITES_KEY = 'group_hiit_local_favorites';
  var CLERK_AUTH_CACHE_KEY = 'group_hiit_clerk_auth_state';
  var SIGN_IN_TITLE = 'Sign in to add to favorite';
  var syncState = {
    promise: null,
    userId: null,
  };

  function getFavoritesStorageKey(userId) {
    return FAVORITES_KEY + ':' + (userId || 'guest');
  }

  function readFavorites(userId) {
    try {
      return JSON.parse(window.localStorage.getItem(getFavoritesStorageKey(userId))) || {};
    } catch (error) {
      return {};
    }
  }

  function writeFavorites(favorites, userId) {
    try {
      window.localStorage.setItem(getFavoritesStorageKey(userId), JSON.stringify(favorites));
    } catch (error) {
      // Favorites still work for the current click even if storage is blocked.
    }
  }

  function getCurrentUser() {
    if (!window.Clerk) return null;
    return window.Clerk.user || (window.Clerk.session && window.Clerk.session.user) || null;
  }

  function getCurrentUserId() {
    var user = getCurrentUser();
    return user && user.id ? user.id : '';
  }

  function isSignedIn() {
    if (getCurrentUserId()) return true;

    try {
      return window.localStorage.getItem(CLERK_AUTH_CACHE_KEY) === 'in';
    } catch (error) {
      return false;
    }
  }

  function getField(item, keys) {
    for (var i = 0; i < keys.length; i += 1) {
      if (item && item[keys[i]] !== undefined && item[keys[i]] !== null && item[keys[i]] !== '') {
        return item[keys[i]];
      }
    }
    return '';
  }

  function getFavoritesArray(payload) {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload.favorites)) return payload.favorites;
    if (payload.data && Array.isArray(payload.data.favorites)) return payload.data.favorites;
    if (payload.data && Array.isArray(payload.data)) return payload.data;
    return [];
  }

  function mapFavoritesFromPayload(payload) {
    var favorites = {};

    getFavoritesArray(payload).forEach(function (item) {
      var product = item && item.product && typeof item.product === 'object' ? item.product : {};
      var source = Object.assign({}, item || {}, product);
      var productId = getField(source, ['product_id', 'productId', 'shopify_product_id', 'shopifyProductId']);

      if (!productId) return;

      favorites[String(productId)] = {
        handle: getField(source, ['handle', 'product_handle', 'productHandle']),
        title: getField(source, ['title', 'product_title', 'productTitle', 'name']),
        addedAt: getField(source, ['saved_at', 'savedAt', 'created_at', 'createdAt']),
      };
    });

    return favorites;
  }

  function getButtonProduct(button) {
    return {
      productId: button.dataset.productId || '',
      productHandle: button.dataset.productHandle || '',
      productTitle: button.dataset.productTitle || '',
    };
  }

  function refreshButton(button, isFavorite) {
    button.classList.toggle('is-favorite', isFavorite);
    button.setAttribute('aria-pressed', isFavorite ? 'true' : 'false');
    button.setAttribute('aria-label', isFavorite ? 'Remove from favorite' : 'Add to favorite');
    button.dataset.favoriteTooltip = isFavorite ? 'Remove from favorite' : 'Add to favorite';

    var text = button.querySelector('[data-favorite-button-text]');
    if (text) {
      text.textContent = isFavorite ? 'Remove from favorite' : 'Add to favorite';
    }
  }

  function setButtonSaving(button, isSaving) {
    button.classList.toggle('is-saving', isSaving);
    button.disabled = isSaving;
    button.setAttribute('aria-busy', isSaving ? 'true' : 'false');
  }

  function hydrateButtons(userId) {
    var favorites = userId ? readFavorites(userId) : {};

    document.querySelectorAll('[data-favorite-product-button]').forEach(function (button) {
      refreshButton(button, !!favorites[button.dataset.productId]);
    });
  }

  function updateFavoriteTitle() {
    var selectors = [
      '.cl-modalContent h1',
      '.cl-modalContent h2',
      '.cl-card h1',
      '.cl-card h2',
      '[class*="headerTitle"]',
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var title = document.querySelector(selectors[i]);
      if (title && /sign in/i.test(title.textContent || '')) {
        title.textContent = SIGN_IN_TITLE;
        return true;
      }
    }

    return false;
  }

  function startFavoriteTitlePolling() {
    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts += 1;
      if (updateFavoriteTitle() || attempts > 40) {
        window.clearInterval(interval);
      }
    }, 100);
  }

  function showFavoriteSignIn() {
    try {
      if (window.Clerk && typeof window.Clerk.openSignIn === 'function') {
        window.Clerk.openSignIn({
          appearance: window.clerkModalAppearance,
        });
        startFavoriteTitlePolling();
        return;
      }

      if (window.ClerkAuth && typeof window.ClerkAuth.openSignIn === 'function') {
        window.ClerkAuth.openSignIn();
        startFavoriteTitlePolling();
      }
    } catch (error) {
      console.error('Unable to open Clerk sign-in for favorites:', error);
    }
  }

  function waitForClerkUser() {
    var currentUser = getCurrentUser();
    if (currentUser && currentUser.id) return Promise.resolve(currentUser);

    return new Promise(function (resolve) {
      var resolved = false;
      var timeout = window.setTimeout(function () {
        done(null);
      }, 5000);

      function done(user) {
        if (resolved) return;
        resolved = true;
        window.clearTimeout(timeout);
        document.removeEventListener('clerk:state-changed', onClerkStateChanged);
        resolve(user);
      }

      function onClerkStateChanged(event) {
        var user = event.detail && event.detail.user ? event.detail.user : null;
        if (user && user.id) {
          done(user);
          return;
        }

        if (event.detail && event.detail.user === null) {
          done(null);
        }
      }

      document.addEventListener('clerk:state-changed', onClerkStateChanged);
    });
  }

  function hasFavoriteButtons() {
    return !!document.querySelector('[data-favorite-product-button]');
  }

  function syncFavoritesFromApi(userId) {
    if (!hasFavoriteButtons()) return Promise.resolve();

    if (!userId || !window.GroupHiitApi || typeof window.GroupHiitApi.getFavorites !== 'function') {
      hydrateButtons(userId);
      return Promise.resolve();
    }

    if (syncState.promise && syncState.userId === userId) return syncState.promise;

    syncState.userId = userId;
    syncState.promise = window.GroupHiitApi.getFavorites({
      clerkUserId: userId,
    })
      .then(function (payload) {
        writeFavorites(mapFavoritesFromPayload(payload), userId);
        hydrateButtons(userId);
      })
      .catch(function (error) {
        console.error('Unable to sync favorites:', error);
        hydrateButtons(userId);
      })
      .finally(function () {
        syncState.promise = null;
      });

    return syncState.promise;
  }

  function setTemporaryTooltip(button, message) {
    var previousTooltip = button.dataset.favoriteTooltip;
    button.dataset.favoriteTooltip = message;

    window.setTimeout(function () {
      button.dataset.favoriteTooltip = previousTooltip;
    }, 2200);
  }

  async function toggleFavorite(button, userId) {
    var product = getButtonProduct(button);
    if (!product.productId) return;

    if (!window.GroupHiitApi || typeof window.GroupHiitApi.addFavorite !== 'function' || typeof window.GroupHiitApi.removeFavorite !== 'function') {
      setTemporaryTooltip(button, 'Favorites API unavailable');
      return;
    }

    var previousFavorites = Object.assign({}, readFavorites(userId));
    var nextFavorites = Object.assign({}, previousFavorites);
    var wasFavorite = !!previousFavorites[product.productId];
    var shouldBeFavorite = !wasFavorite;

    if (shouldBeFavorite) {
      nextFavorites[product.productId] = {
        handle: product.productHandle,
        title: product.productTitle,
        addedAt: new Date().toISOString(),
      };
    } else {
      delete nextFavorites[product.productId];
    }

    setButtonSaving(button, true);
    writeFavorites(nextFavorites, userId);
    refreshButton(button, shouldBeFavorite);
    button.classList.add('favorite-tooltip-hidden');
    button.blur();

    try {
      var params = {
        clerkUserId: userId,
        productId: product.productId,
        productHandle: product.productHandle,
        productTitle: product.productTitle,
      };

      if (shouldBeFavorite) {
        await window.GroupHiitApi.addFavorite(params);
      } else {
        await window.GroupHiitApi.removeFavorite(params);
      }
      syncState.promise = null;  
      syncState.userId = null;   
    } catch (error) {
      writeFavorites(previousFavorites, userId);
      refreshButton(button, wasFavorite);
      setTemporaryTooltip(button, 'Could not update favorite');
      console.error('Unable to update favorite:', error);
    } finally {
      setButtonSaving(button, false);
    }
  }

  async function handleFavoriteClick(button) {
    if (button.classList.contains('is-saving')) return;

    if (!isSignedIn()) {
      showFavoriteSignIn();
      return;
    }

    var user = getCurrentUser();

    if (!user || !user.id) {
      setButtonSaving(button, true);
      user = await waitForClerkUser();
      setButtonSaving(button, false);
    }

    if (!user || !user.id) {
      showFavoriteSignIn();
      return;
    }

    await toggleFavorite(button, user.id);
  }

  function initFavoriteButtons() {
     // Wait for Clerk user to be resolved before hydrating
    var clerkReady = setInterval(function () {
        if (window.Clerk && window.Clerk.user !== undefined) {
            clearInterval(clerkReady);
            var userId = getCurrentUserId();
            hydrateButtons(userId);
            syncFavoritesFromApi(userId);
        }
    }, 50);
    // Fallback: hydrate as guest after 5s if Clerk never loads
    setTimeout(function () {
        clearInterval(clerkReady);
        if (!getCurrentUserId()) hydrateButtons('');
    }, 5000);

   document.addEventListener('click', function (event) {
  if (!(event.target instanceof Element)) return;
  var button = event.target.closest('[data-favorite-product-button]');
  if (!button) return;

  event.preventDefault();
  // Remove event.stopPropagation() entirely
  handleFavoriteClick(button);
});

    document.addEventListener('mouseleave', function (event) {
  if (!(event.target instanceof Element)) return; // ← add this guard
  var button = event.target.closest('[data-favorite-product-button]');
  if (!button) return;
  button.classList.remove('favorite-tooltip-hidden');
}, true);

    document.addEventListener('clerk:state-changed', function (event) {
      var user = event.detail && event.detail.user ? event.detail.user : null;

      if (!user || !user.id) {
        syncState.userId = null;
        syncState.promise = null;
        hydrateButtons('');
        return;
      }

      syncFavoritesFromApi(user.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFavoriteButtons);
  } else {
    initFavoriteButtons();
  }
})();
